export type Step = {
  label: string;
  value: string;
  checked: boolean;
  subheader?: string;
};

export const updatedStepsOnSelect = (nextSteps: Step[], step: Step) => {
  const newNextSteps = nextSteps.map((s) => ({ ...s, checked: false }));
  newNextSteps.filter((s) => s.value === step.value)[0].checked = true;
  return newNextSteps;
};

export const isOptionChecked = (nextSteps: Step[], option: string) => {
  return nextSteps.filter((s) => s.value === option)[0].checked;
};
